import { capitalizeWords } from 'utils';
import { FAMILY_BRANCH_MAP } from 'containers/Family/AddApplication2/familyApplicationConstants';

export function getApplicantFirstName(person) {
  return person?.firstName ? capitalizeWords(person.firstName) : 'the Service Member';
}

export function getOtherAdultFirstName(person) {
  return person?.firstName ? capitalizeWords(person.firstName) : 'the Other Adult';
}

function withOptionalPossessive(name, possessive) {
  if (!possessive) return name;
  return /s$/i.test(name) ? `${name}'` : `${name}'s`;
}

export function getApplicantFullName(person, possessive = false) {
  const first = person?.firstName ? capitalizeWords(person.firstName) : '';
  const last = person?.lastName ? capitalizeWords(person.lastName) : '';

  const full = [first, last].filter(Boolean).join(' ') || 'the Service Member';
  return withOptionalPossessive(full, possessive);
}

export function getOtherAdultFullName(person, possessive = false) {
  const first = person?.firstName ? capitalizeWords(person.firstName) : '';
  const last = person?.lastName ? capitalizeWords(person.lastName) : '';

  const full = [first, last].filter(Boolean).join(' ') || 'the Other Adult';
  return withOptionalPossessive(full, possessive);
}

export function getBranchNameById(branchId) {
  const branch = Object.values(FAMILY_BRANCH_MAP).find((b) => b.id === branchId);
  return branch ? branch.title : '';
}
